import type { UsuarioDev } from './contexto';
import { ETIQUETA_ROL } from '../lib/etiquetas';
import { iniciales } from '../lib/formato';

interface Props {
  modo: 'entra' | 'dev';
  alIniciar?: () => void;
  usuariosDev?: UsuarioDev[];
  alElegirUsuario?: (oid: string) => void;
  mensaje?: string | null;
  cargando?: boolean;
}

export function PantallaAcceso({ modo, alIniciar, usuariosDev, alElegirUsuario, mensaje, cargando }: Props) {
  return (
    <main className="acceso">
      <section className="acceso__panel" aria-labelledby="acceso-titulo">
        <img src={`${import.meta.env.BASE_URL}logo-upk-marca.png`} alt="UPK" className="acceso__logo" />
        <h1 id="acceso-titulo" className="acceso__titulo">
          UPK INNOVA Colombia
        </h1>
        <p className="acceso__sub">Plataforma de UP KEEP SERVICES S.A.S. · Módulo Preventa</p>
        {mensaje && (
          <div className="aviso aviso--error" role="alert">
            {mensaje}
          </div>
        )}
        {modo === 'entra' ? (
          <button className="btn btn--primario btn--bloque" onClick={alIniciar} disabled={cargando}>
            {cargando ? 'Conectando…' : 'Iniciar sesión con Microsoft'}
          </button>
        ) : (
          <>
            <p className="acceso__nota">Modo de desarrollo. Elija un usuario de prueba para entrar con sus roles.</p>
            <ul className="acceso__usuarios">
              {usuariosDev?.map((u) => (
                <li key={u.oid}>
                  <button className="acceso__usuario" onClick={() => alElegirUsuario?.(u.oid)}>
                    <span className="avatar" aria-hidden="true">
                      {iniciales(u.nombre)}
                    </span>
                    <span>
                      <strong>{u.nombre}</strong>
                      <small>{u.roles.map((r) => ETIQUETA_ROL[r]).join(', ')}</small>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}
        <p className="acceso__pie">Acceso restringido a personal autorizado de UPK.</p>
      </section>
    </main>
  );
}
